import { useQuery } from '@tanstack/react-query';
import { authServices } from '../services/auth.service';

export const useUserProfile = () => {
  return useQuery({
    queryKey: ['user-profile'],
    queryFn: () => authServices.userProfile(),
    staleTime: 10 * 60 * 1000, // 10 minutes
  });
};
